import { AdmService } from 'src/app/shared/services/adm.service';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfirmacionDialogComponent } from 'src/app/shared/components/confirmacion-dialog/confirmacion-dialog.component';
import { DatePipe, DecimalPipe } from '@angular/common'
import { isMobile, isMobileXL, toFormData } from 'src/app/shared/utils/helpers';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { CuotaPlanta } from 'src/app/shared/models/cuotaPlanta';
import { ProductosService } from 'src/app/shared/services/productos.service';
import { CuotasPlantasDialogComponent } from './cuotas-plantas-dialog.component';
import { StockPedidosDialogComponent } from 'src/app/shared/components/stock-pedidos-dialog/stock-pedidos-dialog.component';
import { ExcelService } from 'src/app/shared/services/excel.service';
import { HttpResponse } from '@angular/common/http';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-cuotas-plantas',
  templateUrl: './cuotas-plantas.component.html'
})
export class CuotasPlantasComponent {
  constructor(private configService: ConfigService,
    private dialog: MatDialog,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    private productosService: ProductosService,
    private admService: AdmService,
    public excelService: ExcelService) { }
  displayedColumns = ['acciones', 'idProducto', 'producto', 'mes','anio','idPlanta','idUbicacionAlmacenamiento','cantidadDisponibleVigente','cantidadPedidosNoFacturados','cantidadDisponibleVenta'];
  dataSource = new MatTableDataSource<CuotaPlanta>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  botonSubidaExcel: string = "";

  loadingSubidaExcel: boolean = false;

  public Etiquetas: {
    BotonACuotaPlanta: string;
    BotonAExcel: string;
    BotonCPlantillaExcel: string;
    Buscar: string,
    SinRegistros: string,
    Titulo: string,
    Headers: {
      Acciones: string,
      IdCompania: string,
      IdSalesOrg: string,
      IdProducto: string,
      Producto: string,
      Mes: string,
      Anio:string,
      IdPlanta: string,
      IdUbicacionAlmacenamiento: string,
    
      CantidadDisponibleVigente: string;
      CantidadPedidosNoFacturados: string;
      CantidadDisponibleVenta: string;
    }
  }
  public Tooltips: {
    Editar: string,
    Ver: string,
    Eliminar: string
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sort.disableClear = true;

  }

  ngOnInit(): void {
    if (!this.loggedService.isInRole('ADM') && !this.loggedService.isInRole('ADMVENTAS') && !this.loggedService.isInRole('ADM LOCAL') && !this.loggedService.isInRole('LOGISTICA')) {
      this.router.navigateByUrl('');
    }
    this.Tooltips = {
      Editar: this.configService.tooltips.Editar,
      Ver: this.configService.tooltips.Ver,
      Eliminar: this.configService.tooltips.Eliminar
    }
    this.Etiquetas = {
      BotonACuotaPlanta: this.configService.etiquetas.CuotasPlantas.BotonACuotaPlanta,
      BotonAExcel: this.configService.etiquetas.BotonAExcel,
      BotonCPlantillaExcel: this.configService.etiquetas.BotonCPlantillaExcel,
      Titulo: this.configService.etiquetas.CuotasPlantas.Titulo,
      Buscar: this.configService.etiquetas.Buscar,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      Headers: {
        Acciones: this.configService.etiquetas.Acciones,
        IdCompania: this.configService.etiquetas.Compania,
        IdSalesOrg: this.configService.etiquetas.SalesOrg,
        IdProducto: this.configService.etiquetas.IdProducto,
        Producto: this.configService.etiquetas.Producto,
        Mes: this.configService.etiquetas.Mes,
        Anio: this.configService.etiquetas.Anio,
        IdPlanta: this.configService.etiquetas.IdPlanta,
        IdUbicacionAlmacenamiento: this.configService.etiquetas.StorageLocation,
       
        CantidadDisponibleVigente:  this.configService.etiquetas.CantidadDisponibleVigente,
        CantidadPedidosNoFacturados:  this.configService.etiquetas.CantidadPedidosNoFacturados,
        CantidadDisponibleVenta:  this.configService.etiquetas.CantidadDisponibleVenta,

      }
    }
    this.buscar(0);
    this.botonSubidaExcel = this.Etiquetas.BotonAExcel;
  }
  buscar(idTipoMensaje: number) {
    this.productosService
      .cCuotasPlantas(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg)
      .subscribe((data:  CuotaPlanta[]) => {
        this.dataSource.data = [];
        if (data.length) {

          this.dataSource.data = data;
          switch (idTipoMensaje) {
            case 1:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 1, 1)
              break;
            case 2:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 1)
              break;
            case 3:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.EliminacionExitosa, 1, 1)
              break;
              case 4:
                this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExcelExitosa, 1, 1)
                break;

          }
        }

      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  dialogCuotasPlantas(idTipo: number, c: CuotaPlanta) {

    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { c: c, idTipo: idTipo }
    let dialogRef = this.dialog.open(CuotasPlantasDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: number) => {
      if (data != 0) {
        this.buscar(idTipo);
      }
    })
  }
  eliminar(c: CuotaPlanta) {
    this.dialog
      .open(ConfirmacionDialogComponent, { panelClass: 'app-dialog', data: "¿Confirmas la eliminación de la cuota planta " + c.producto + "?", width: 'auto', height: 'auto' })
      .afterClosed()
      .subscribe((Si: boolean) => {
        if (Si) {
          this.productosService.bCuotaPlanta(c).subscribe((data: boolean) => {

            this.buscar(3);
          })
        }
      })
  }

  
  dialogStockPedidos(c: CuotaPlanta) {
    if (c.listaStockPedidos.length) {
      let config: MatDialogConfig = new MatDialogConfig();
      config.width = '100%';
      config.height = 'auto';
      config.data = { s: c.listaStockPedidos }
      let dialogRef = this.dialog.open(StockPedidosDialogComponent, config);
      dialogRef.afterClosed().subscribe((data: number) => {

      })
    }
  }
  cPlantillaAltaMasiva() {
    this.excelService.cPlantillaAltaMasivaCuotasPlantas();
    }
  aCuotasPlantasExcel(fileInputEvent: any) {

    if (fileInputEvent.target.files.length) {

      if ((fileInputEvent.target.files[0].name.substring(fileInputEvent.target.files[0].name.lastIndexOf('.') + 1) != 'xls') && (fileInputEvent.target.files[0].name.substring(fileInputEvent.target.files[0].name.lastIndexOf('.') + 1) != 'xlsx')) {

        this.snackBarService.openSnackbar(this.configService.mensajes.TituloError, this.configService.validaciones.ArchivoInvalido, 0, 1)
      }
      else {
        let data = {
          Autor: this.loggedService.logged.userName,
        };
        let form = toFormData(data);
        for (let index = 0; index < fileInputEvent.target.files.length; index++) {
          let element = fileInputEvent.target.files[index];
          form.append('ExcelCuotasPlantas', element);
        }
        this.loadingSubidaExcel = true;
        this.botonSubidaExcel = this.configService.etiquetas.Subiendo;
        let timer = setTimeout(() => {
          this.loadingSubidaExcel = false;
          this.botonSubidaExcel = this.Etiquetas.BotonAExcel;
        }, 120000);
        this.productosService.aCuotasPlantasExcel(form).subscribe((resp: HttpResponse<Blob>) => {
          if (resp.body != null) {

            let customHeader: string;
            customHeader = resp.headers.get('x-custom'); // Header con nombre de archivo y código de error

            if (customHeader != null) {
              let headers: string[] = [];
              headers = customHeader.split(',');
              let headersTrim: string[] = [];
              if (headers.length) {
                headers.forEach(element => {
                  headersTrim.push(element.trim());
                });
              }
              if (headersTrim.length) {
                let fileName = headersTrim[0];
                let errorCode = headersTrim[headersTrim.length - 1];
                if (errorCode.length) {
                  switch (errorCode) {
                    case "0": // Sin error
                      if (resp.body.size) {
                        FileSaver.saveAs(resp.body, fileName + ".log");
                      }
                      this.buscar(4);
                      break;
                    case "1": // Excel inválido
                      this.snackBarService.openSnackbar(this.configService.mensajes.TituloError, this.configService.validaciones.ArchivoExcelInvalido, 0, 1)
                      break;
                    case "2":// Excel con información inválida
                      FileSaver.saveAs(resp.body, fileName + ".log");
                      this.snackBarService.openSnackbar(this.configService.mensajes.TituloWarning, this.configService.validaciones.ArchivoExcelVacio, 3, 1)
                      break;
                  }
                }

              }
            }
          }
          this.loadingSubidaExcel = false;
          this.botonSubidaExcel = this.Etiquetas.BotonAExcel;
        });
      }


    }

  }

  isLogged() {
    return this.loggedService.logged != null;
  }

  isNewUser() {
    if (this.loggedService.logged != null) {
      return this.loggedService.logged.newUser;
    }
    else {
      return false
    }
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }
}
